import request from 'graphql-request';
import { SWRConfiguration } from 'swr';
import config from 'src/config';

export function swrFetcher<T>(GQL: string, variables?: T) {
    return request(`${config.baseUrl}/api/graphql`, GQL, variables);
}

export const nopeFetcher: SWRConfiguration = {
    revalidateOnFocus: false,
    revalidateOnMount: false,
    revalidateOnReconnect: false,
    refreshWhenOffline: false,
    refreshWhenHidden: false,
    refreshInterval: 0,
    fetcher: () => {}
};
